<div cdkDrag [cdkDragData]="data">
  <div [ngClass]="data.placeholderClassName" *cdkDragPlaceholder></div>
  <div [id]="data.id" class="widget-area" [ngClass]="data.isSelected ? 'widget-selected' : 'widget-unselected'"
    cdkDropList [cdkDropListConnectedTo]="dropListIds" [cdkDropListData]="data.children"
    [cdkDropListEnterPredicate]="isDroppableWidget" (cdkDropListDropped)="onDrop($event)">
    <!-- Titlebar for Widget -->
    <div class="widget-top-bar" fxLayout="row nowrap" fxLayoutAlign="end start">
      <mat-icon class="drag-handler" cdkDragHandle>drag_indicator</mat-icon>
      <mat-label fxFlex="grow" title="{{ data.id }}" (click)="onSelect($event)"><b>{{ data.key }}</b><b
       *ngIf="data.label"> [{{data.label}}]</b></mat-label>
       <img src="assets/img/icons/field.png">
      <mat-icon class="top-icon" (click)="onDeleteModal()">delete</mat-icon>
      <mat-icon *ngIf="!isMinimized" class="top-icon" (click)="onMinimize()">minimize</mat-icon>
      <mat-icon *ngIf="!isMinimized" class="top-icon" (click)="onMaximize()">settings</mat-icon>
    </div>

    <!-- Config data for Widget -->
    <div *ngIf="!isMinimized">
      <app-metadata-builtin-field [data]="data"></app-metadata-builtin-field>
      <!--
      <appMetadataWidget [data]="data"></appMetadataWidget>
      <app-metadata-field [data]="data"></app-metadata-field>
      <div class="widget-config">
        <h5 class="block-title">Primitive Properties</h5>
        <p><b>Key:</b> {{data.key}}</p>
        <div fxLayout="row wrap">
          <select
            class="widget-attrib"
            [(ngModel)]="data.type"
            (ngModelChange)="onTypeSelected($event)">
            <option value="datepicker selected">Datepicker</option>
            <option value="time">Time</option>
            <option value="date">Date</option>            
            <option value="textarea">Textarea</option>
            <option value="radio">Radio</option>
            <option value="checkbox">Checkbox</option>
            <option value="input" selected>Input</option>
 
              <option value="paragraph">Paragraph</option>
              <option value="toggle">Toggle</option>
              <option value="slider">Slider</option>
            <option value="select">Select</option>
            <option value="multi-select">MultiSelect</option>
          </select>
          <label for="label" title="{{ data.id }}">Label</label>
          <input
            class="widget-attrib"
            id="label"
            type="text"
            placeholder="{{ data.label }}"
            [(ngModel)]="data.label"
          />
          <label class="widget-attrib" for="desc">Description</label>
          <input
            class="widget-attrib"
            id="desc"
            type="text"
            [(ngModel)]="data.description"
          />
          <label
            ><input
              class="widget-attrib"
              type="checkbox"
              [(ngModel)]="data.required"
            />Required</label>
        </div>
      </div>
      -->
    </div>

    <!-- Validation container for Widget -->
    <div *ngIf="!isMinimized" class="widget-config" fxLayout="column wrap">
      <h5 class="block-title">Validations</h5>
      <ng-container *ngFor="let widget of data.children">
        <ng-container [ngSwitch]="widget.widgetType">
          <div appValdnWidgetsComparison [data]="$any(widget)" *ngSwitchCase="WidgetsTypeEnum.VALDN_COMP"></div>
          <div appValdnWidgetsDate [data]="$any(widget)" *ngSwitchCase="WidgetsTypeEnum.VALDN_DATE"></div>
          <div appValdnWidgetsIP [data]="$any(widget)" *ngSwitchCase="WidgetsTypeEnum.VALDN_IP"></div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>